import css from "styled-jsx/css";
import { grid, colors } from "../constants";

export default css`
  .backround {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    // :global(.image),
    // .linear-gradient {
    //   position: absolute;
    //   top: 0;
    //   left: 0;
    //   width: 100%;
    //   height: 100%;
    //   object-fit: cover;
    //   display: block;
    // }

    .linear-gradient {
      display: none;
    }

    @media screen and (min-width: ${grid.breakpoint_sm}px) {
      .linear-gradient {
        display: block;
        background: linear-gradient(
          90deg,
          rgba(49, 50, 53, 0) 0%,
          rgba(49, 50, 53, 0.30015756302521013) 46%,
          rgba(49, 50, 53, 0.6026785714285714) 63%,
          rgba(49, 50, 53, 0.804359243697479) 100%
        );
      }
    }
  }
`;
